/* =============================================================
   IMPULSE — LP Whey Isolate — Add To Cart
   assets/lugus-lp-atc.js
   ============================================================= */

(function () {

  var VARIANT_IDS = {
    'Chocolat': 51887753003339,
    'Vanille':  51857626136907,
    'Nature':   51857627513163
  };

  var FORMAT_QTY = {
    '750g':   1,
    '1,5kg':  2,
    '2,25kg': 3
  };

  function getActiveFlavor() {
    var btn = document.querySelector('.lp-flavor__btn.is-active');
    return btn ? (btn.getAttribute('data-flavor') || 'Nature') : 'Nature';
  }

  function getSelectedFormat() {
    var card = document.querySelector('.lp-format-card.is-selected');
    if (!card) return '750g';
    var nameEl = card.querySelector('.lp-format-card__name');
    return nameEl ? nameEl.textContent.trim() : '750g';
  }

  function setBtnState(btn, state) {
    if (!btn) return;
    if (state === 'loading') {
      btn.setAttribute('data-original', btn.textContent.trim());
      btn.textContent = 'Ajout en cours…';
      btn.style.opacity = '0.7';
      btn.style.pointerEvents = 'none';
    } else if (state === 'success') {
      btn.textContent = '✓ Ajouté au panier';
      btn.style.opacity = '1';
      setTimeout(function () {
        btn.textContent = btn.getAttribute('data-original') || 'Ajouter au panier';
        btn.style.pointerEvents = '';
      }, 1500);
    } else if (state === 'error') {
      btn.textContent = 'Erreur — réessayer';
      btn.style.opacity = '1';
      setTimeout(function () {
        btn.textContent = btn.getAttribute('data-original') || 'Ajouter au panier';
        btn.style.pointerEvents = '';
      }, 2500);
    }
  }

  function addToCart(btn) {
    var flavor    = getActiveFlavor();
    var format    = getSelectedFormat();
    var variantId = VARIANT_IDS[flavor];
    var quantity  = FORMAT_QTY[format] || 1;

    if (!variantId) {
      console.warn('[LP ATC] Variant introuvable pour :', flavor);
      setBtnState(btn, 'error');
      return;
    }

    setBtnState(btn, 'loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    })
    .then(function () {
      setBtnState(btn, 'success');

      // Le drawer Lugus ne peut pas être correctement initialisé
      // depuis une LP sans PDP. On utilise le mécanisme déjà présent
      // dans theme.liquid : impulse_open_cart_drawer en sessionStorage.
      // Au reload de la page, le script dans theme.liquid ouvre
      // automatiquement le drawer via le mécanisme natif du thème.
      try {
        sessionStorage.setItem('impulse_open_cart_drawer', '1');
      } catch (e) {}

      // Recharger la page après un court délai pour que l'utilisateur
      // voie le feedback "✓ Ajouté au panier" avant le reload
      setTimeout(function () {
        window.location.reload();
      }, 1200);
    })
    .catch(function (err) {
      console.error('[LP ATC] Erreur :', err);
      setBtnState(btn, 'error');
    });
  }

  function init() {
    var stickyBtn = document.getElementById('lp-sticky-cta');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart(stickyBtn);
      });
    }

    var mainBtn = document.getElementById('lp-cta-main-btn');
    if (mainBtn) {
      mainBtn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart(mainBtn);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();